<template>
  <div class="step step_last" :class="{ 'form__step_hidden': step != number }" :aria-labelledby="`step${number}-title`">
    <h3 class="form__title">Согласие на обработку персональных данных*</h3>
    <CheckboxInput v-model="stepsdata[number][names[0]]" :name="names[0]" descr="Я ознакомился с Пользовательским соглашением, политикой обработки персональных данных (ПД) и даю согласие на обработку ПД*" />

    <h3 v-if="captchaMode" class="form__title">Подтвердите, что Вы не робот*</h3>
    <div v-show="captchaMode" id="captcha-container" class="smart-captcha" data-sitekey="D5EbUa8ujnEQDrRS2lt7b5GRBnHRNromvC9U7DF4" style="height: 100px; box-sizing: content-box; ">
    </div>


    <h3 v-if="!captchaMode" class="form__title">На Ваш номер отправлен&nbsp;код*</h3>
    <p v-if="!captchaMode && currentTel" class="form__text">Код отправлен на номер <b class="nowrap">{{ currentTel }}</b></p>
    <p v-if="!captchaMode" class="form__text pt0" :class="{ 'form__text_hidden': tries > 2 }">Если Ваш номер указан не верно, то Вы можете
      <a class="form__text-redlink" @click.prevent="tries < 3 ? showPopup = true : false">изменить</a>
      его
    </p>
    <NumberInput v-if="!captchaMode" :forceError="(IsCodeChecked && !IsCodeCorrect) ? 'Неверный код' : ''" :errorcont="errorcont" :filled="(v) => v.length == 4" :required="true" v-model="code" mask="####" name="code" :increased="!tel" text="Введите код из SMS" />
    <div v-if="!captchaMode" class="form__timertext">
      <p v-if="codeSeconds">Повторная отправка доступна через <b>{{ timerstring }}</b></p>
      <a v-else class="form__timertext-link" @click="$store.dispatch('sendCode')" :disabled="codeSeconds">Запросить повторно</a>
    </div>
    <Teleport to=".form">
      <Popup :value="showPopup && !captchaMode" @input="showPopup = $event">
        <h3 class="popup__title">Введите номер мобильного&nbsp;телефона</h3>
        <NumberInput mask="+7 (###) ###-##-##" @setError="telError = $event" :filled="(v) => v.length == 18" v-model="tel" text="Номер мобильного телефона" name="clientmobphone-change" />
        <Btn @click.native.stop.prevent="changeTel" class="popup__btn" :disabled="telError || !tel || !changeTelCondition">
          <span v-if="changeTelCondition">Подтвердить</span>
          <span v-else>Ожидайте {{ timerstring }}</span>
        </Btn>
      </Popup>
    </Teleport>

    <div class="form__btns">
      <Btn class="btn_gray" @click.native.prevent="$store.commit('prevStep')">Назад</Btn>
      <Btn @click.native.prevent="modeAction" :disabled="!filled() || step != number">Отправить</Btn>
    </div>
  </div>
</template>

<script>
import Btn from './ui/Btn.vue'
import NumberInput from './NumberInput.vue'
import { mapGetters, mapState } from 'vuex'
import CheckboxInput from './CheckboxInput.vue'
import Teleport from 'vue2-teleport'
import Popup from './Popup.vue'
export default {
  data: () => ({
    names: ['agreementpersonaldataprocessing'],
    mountcount: -1,
    tries: 0,
    code: '',
    IsCodeCorrect: false,
    IsCodeChecked: false,
    showPopup: false,
    errorCount: 0,
    tel: '',
    telError: '',
    errorcont: {},
    captchaInited: false
  }),
  components: { Btn, CheckboxInput, NumberInput, Teleport, Popup },
  props: {
    number: { type: Number, default: 14 }
  },
  mounted() {
    this.mountcount++
    if (this.mountcount)
      return console.error('lastStep mounted twice')
    if (this.captchaMode)
      this.initCaptcha()
  },
  methods: {
    initCaptcha() {
      if (this.captchaInited)
        return

      window.onloadFunction = this.verify.bind(this)
      let script = document.createElement('script')
      script.setAttribute('src', "https://captcha-api.yandex.ru/captcha.js?render=onload&onload=onloadFunction")
      script.setAttribute('defer', '')
      document.body.appendChild(script)
    },
    filled() {
      if (this.captchaMode && !this.captchaPassed)
        return false
      if (!this.captchaMode && this.code.length != 4)
        return false
      return this.stepsdata[this.number][this.names[0]]
    },
    verify() {
      if (window.smartCaptcha) {
        const container = document.getElementById('captcha-container');
        const widgetId = window.smartCaptcha.render(container, {
          sitekey: 'D5EbUa8ujnEQDrRS2lt7b5GRBnHRNromvC9U7DF4',
          hl: 'ru',
        })
        window.smartCaptcha.subscribe(widgetId, 'success',
          () => {
            const response = window.smartCaptcha.getResponse(widgetId)
            if (!response)
              return console.error('Ответ капчи - пустой')
            this.$store.commit('setCaptcha', true)
            this.stepsdata[this.number]['g-recaptcha-response'] = response
          })
      }
    },
    changeTel(e) {
      console.log(e)
      if (e) {
        e.stopPropagation()
        e.preventDefault()
      }
      if (!this.changeTelCondition) return
      if (!this.stepsdata[3] || !this.stepsdata[3].clientmobphone) {
        this.$store.dispatch('throwError', {
          title: 'Ошибка',
          text: 'Слайд с данными о клиенте не был заполнен, отправка смс невозможна',
          btn: 'Ок'
        })
        return this.showPopup = false
      }
      this.stepsdata[3].clientmobphone = this.tel
      this.showPopup = false
      this.tries++
      this.$store.dispatch('sendCode', true)
    },
    modeAction() {
      if (this.captchaMode)
        this.$store.dispatch('sendForm')
      else
        this.checkCode()
    },
    async checkCode() {
      let v = this.code
      this.IsCodeChecked = false
      this.IsCodeCorrect = false
      if (v.length < 4) return
      this.IsCodeCorrect = await this.$store.dispatch('checkCode', v)
      if (['die', null].includes(this.IsCodeCorrect)) {
        let text = 'Попробуйте повторить запрос'
        if (this.IsCodeCorrect == 'die')
          text = 'Что-то пошло не так, возникла техническая&nbsp;ошибка<br>Для решения вопроса обратитесь к менеджеру <b><a class="newred nowrap" href="tel:88007007333">8 800 700 7 333</a><b>'
        this.IsCodeCorrect = null
        return this.$store.dispatch('throwError', {
          title: 'Ошибка!',
          text: text,
          btn: 'Повторить',
          action: () => this.checkCode()
        })
      }
      this.IsCodeChecked = true
      if (this.IsCodeCorrect)
        this.$store.dispatch('sendForm')
      else
        this.errorCount++

      if (this.errorCount == 5) {
        this.errorCount = 0
        this.$store.dispatch('throwError', {
          title: 'Запросите новый код',
          text: 'Предыдущий код подтверждения более не активен, запросите новый код',
          btn: 'Ок'
        })
      }
    }
  },
  computed: {
    ...mapState(['stepsdata', 'step', 'codeSeconds', 'captchaPassed']),
    ...mapGetters(['timerstring', 'cobscount']),
    currentTel() {
      return this.stepsdata[3].clientmobphone
    },
    changeTelCondition() {
      if (!this.tries) return true
      if (this.tries > 2) return false
      return this.codeSeconds ? false : true
    },
    captchaMode() {
      if (this.cobscount)
        return true
      return false
    }
  },
  watch: {
    step(v, old) {
      if (v != old && v == this.number && !this.captchaMode)
        this.$store.dispatch('sendCode')
    },
    code(v, old) {
      if (v != old) {
        this.IsCodeChecked = false
        this.IsCodeCorrect = false
      }
    },
    captchaMode(v, old) {
      if (v && (v != old)) {
        this.initCaptcha()
      }
    }
  }

}
</script>

<style lang="sass">
.step__hiddencaptcha
  visibility: hidden
  opacity: 0
  position: absolute
  pointer-events: none
</style>